import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Shown when a user lacks the required admin role for tenant onboarding.
 */
const AdminAccessDenied = () => (
    <Container>
        <br /><br />
        <Row className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center justify-content-center">
            <br /><br />
            <h1 className="text-danger">Access Denied</h1>
            <h5>
                You do not have the required administrative role to access this page.
            </h5>
            <p className="mt-3">
                <Link to="/landing">Return to home</Link>
            </p>
        </Row>
    </Container>
);

export default AdminAccessDenied;
